import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { theme } from '@whitbread-eos/atoms';
import { useSemanticTypography } from '@whitbread-eos/utils';
import React from 'react';
import RoomFacilitiesList from '../Facilities/RoomFacilities';
import HotelRoomImages from '../HotelRoomImages';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HotelRoomContent = _ref => {
  var tabItems = _ref.tabItems,
    isLessThanSm = _ref.isLessThanSm,
    isLessThanMd = _ref.isLessThanMd,
    isLessThanLg = _ref.isLessThanLg,
    containerRef = _ref.containerRef;
  var getTypographyProps = useSemanticTypography();
  var roomNameLegacyTypography = {
    fontSize: {
      base: 'md',
      sm: '1.188rem'
    },
    lineHeight: 3,
    fontWeight: 'semibold'
  };
  var roomNameSemanticTypography = {
    textStyle: 'heading-s'
  };
  var roomDescriptionLegacyTypography = {};
  var roomDescriptionSemanticTypography = {
    textStyle: 'body-m-regular'
  };
  var isRelativeToContainer = !!containerRef;
  return _jsx(Flex, {
    overflowX: "auto",
    margin: isRelativeToContainer ? 0 : -4,
    children: tabItems === null || tabItems === void 0 ? void 0 : tabItems.map((tabItem, idx) => _jsxs(Flex, _objectSpread(_objectSpread({}, cardStyles(idx)), {}, {
      children: [_jsx(Box, {
        flex: 1,
        children: _jsx(HotelRoomImages, {
          images: tabItem === null || tabItem === void 0 ? void 0 : tabItem.images,
          thumbnailHeight: getThumbnailHeight(),
          isLessThanSm: isLessThanSm,
          isLessThanLg: isLessThanLg,
          containerRef: containerRef
        })
      }), _jsxs(Box, {
        flex: 1,
        p: 6,
        children: [!isRelativeToContainer && _jsx(Text, _objectSpread(_objectSpread({}, getTypographyProps(roomNameLegacyTypography, roomNameSemanticTypography)), {}, {
          "data-testid": "hdp_roomName-".concat(tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomName),
          children: tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomName
        })), _jsx(Text, _objectSpread(_objectSpread({
          mt: 2,
          mb: "lg",
          color: theme.colors.darkGrey2
        }, getTypographyProps(roomDescriptionLegacyTypography, roomDescriptionSemanticTypography)), {}, {
          "data-testid": "hdp_roomDescription-".concat(tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomName),
          children: tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomDescription
        })), _jsx(RoomFacilitiesList, {
          facilities: tabItem.facilities,
          isLessThanSm: isLessThanSm,
          isLessThanMd: isLessThanMd,
          containerRef: containerRef
        })]
      })]
    }), tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomName))
  });
  function cardStyles(tabItemIdx) {
    return {
      border: "1px solid ".concat(theme.colors.lightGrey3),
      borderRadius: 'base',
      mt: isRelativeToContainer ? '3rem' : 6,
      mb: isRelativeToContainer ? 0 : 3,
      width: 'full',
      direction: {
        base: 'column',
        mobile: 'column',
        sm: 'column',
        md: 'column',
        lg: tabItems && tabItems.length > 1 || isRelativeToContainer ? 'column' : 'row',
        xl: tabItems && tabItems.length > 1 || isRelativeToContainer ? 'column' : 'row'
      },
      mr: tabItems && (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) > 1 && tabItemIdx < (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) - 1 ? 6 : 0,
      minWidth: isRelativeToContainer ? 'unset' : getCardMinWidth(),
      maxWidth: isRelativeToContainer ? 'unset' : {
        base: 'full',
        md: tabItems && (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) > 1 ? 'full' : '38.875rem',
        lg: 'full'
      }
    };
    function getCardMinWidth() {
      switch (true) {
        case tabItems && tabItems.length > 1 && tabItems.length <= 4:
          return {
            xl: "calc(100% / ".concat(tabItems === null || tabItems === void 0 ? void 0 : tabItems.length, " - 1.5rem + 1.5rem / ").concat(tabItems === null || tabItems === void 0 ? void 0 : tabItems.length, ")"),
            lg: "calc(100% / ".concat(tabItems === null || tabItems === void 0 ? void 0 : tabItems.length, " - 1.5rem + 1.5rem / ").concat(tabItems === null || tabItems === void 0 ? void 0 : tabItems.length, ")"),
            md: '39.813rem',
            sm: '29.438rem',
            mobile: '19.438rem',
            base: '16rem'
          };
        case tabItems && (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) > 4:
          return {
            xl: "calc(100% / 4 - 1.5rem + 1.5rem / 4)",
            lg: "calc(100% / 4 - 1.5rem + 1.5rem / 4)",
            md: '39.813rem',
            sm: '29.438rem',
            mobile: '19.438rem',
            base: '16rem'
          };
        default:
          return {
            xl: 'full',
            lg: 'full',
            md: '38.875rem',
            sm: 'full',
            mobile: 'full',
            base: 'full'
          };
      }
    }
  }
  function getThumbnailHeight() {
    switch (true) {
      case (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) === 2:
        return {
          xl: '22.563rem',
          lg: '21.125rem',
          md: '22.063rem',
          sm: '16.563rem',
          mobile: '10.625rem',
          base: '10.625rem'
        };
      case (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) === 3:
        return {
          xl: '14.75rem',
          lg: '13rem',
          md: '22.063rem',
          sm: '16.563rem',
          mobile: '10.625rem',
          base: '10.625rem'
        };
      case tabItems && (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) >= 4:
        return {
          xl: '10.875rem',
          lg: '10rem',
          md: '22.063rem',
          sm: '16.563rem',
          mobile: '10.625rem',
          base: '10.625rem'
        };
      default:
        return {
          xl: '22.563rem',
          lg: '22rem',
          md: '24rem',
          sm: '16.563rem',
          mobile: '10.625rem',
          base: '10.625rem'
        };
    }
  }
};